/** returns object */

export default {
    user: state => state.user,
    fiscalyear: state => state.fiscal_year,
    batch: state => state.batch,
    student: state => state.student
}
